const messages = {
    _default: (field) => `Das Fled ${field} ist nicht korrekt.`,
    required: (field) => `${field} ist ein Pflichtfeld.`,
}

const attributes = {
    first_name: "Vorname",
    last_name: "Nachname",
    middle_name: "2ter Vorname",
    email: "E-Mail",
    password1: "Password",
    "confirm-password": "wiederholtes Passwort",
    name1: "Firmenname",
    address1: "Addresse",
    zip: "Postleitzeil",
    city: "Stadt",
    country: "Land"
}

const locale = {
    name: 'en',
    messages,
    attributes: attributes
  }

  export default locale
